import type { GetBalancesResponse } from "@defuse-protocol/one-click-sdk-typescript"
import appQueryClient from "@src/constants/queryClient"
import type { QueryObserverOptions } from "@tanstack/react-query"
import type { IntentsUserId } from "../../../types/intentsUserId"
import { assert } from "../../../utils/assert"
import { getPrivateBalance } from "../../machines/privateIntents"

type PrivateBalanceQueryKey = [
  "intents_sdk.private_balance",
  { userId: null | IntentsUserId; tokenIds?: string[] },
]

export function invalidatePrivateBalanceQueries() {
  void appQueryClient.invalidateQueries({
    queryKey: ["intents_sdk.private_balance"],
  })
}

export function removePrivateBalanceQueries() {
  appQueryClient.removeQueries({
    queryKey: ["intents_sdk.private_balance"],
  })
}

export function createPrivateBalanceQueryOptions(
  {
    userId,
    tokenIds,
  }: {
    userId: null | IntentsUserId
    tokenIds?: string[]
  },
  enabled = true
) {
  return {
    queryKey: ["intents_sdk.private_balance", { userId, tokenIds }],
    queryFn: async ({ queryKey }) => {
      assert(queryKey[1].userId != null)

      const result = await getPrivateBalance({ tokenIds: queryKey[1].tokenIds })
      if ("err" in result) {
        throw new Error(result.err)
      }

      return result.ok
    },
    enabled: (query) => query.queryKey[1].userId != null && enabled,
    refetchInterval: 15000,
  } satisfies QueryObserverOptions<
    GetBalancesResponse,
    Error,
    GetBalancesResponse,
    GetBalancesResponse,
    PrivateBalanceQueryKey
  >
}
